module.exports = __webpack_public_path__ + "static/media/stkilda.bc8b4d97.svg";